
import { request } from './request';
import { 
  getFileUploadRequestConfig, 
} from './config';

export function uploadBloodPressureDeviceCsv (formData) {
  const config = getFileUploadRequestConfig(formData, null, '/file/uploadBloodPressure');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function uploadWeightBloodPressureDeviceCsv (formData) {
  const config = getFileUploadRequestConfig(formData, null, '/file/uploadWeightBloodPressure');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function uploadFreeStyleLibreLinkDeviceCsv (formData) {
  const config = getFileUploadRequestConfig(formData, null, '/file/uploadFreeStyleLibreLink');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function uploadFreeStyleLibreLinkDeviceCsv2 (formData) {
  const config = getFileUploadRequestConfig(formData, null, '/file/uploadFreeStyleLibreLink2');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function uploadForeDeviceCsv (formData) {
  const config = getFileUploadRequestConfig(formData, null, '/file/uploadFore');
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}
